/**
 * Utilidades para el manejo de categorías y subcategorías en TreeView
 * @module categoriesUtil
 */

/**
 * Obtiene los IDs de todos los nodos ancestros de un nodo dado
 * @function getParentIds
 * @param {Array} categories - Lista plana de categorías con { id, parentId }
 * @param {number|string} targetId - ID del nodo objetivo
 * @returns {Array<number|string>} Array de IDs ancestros (del más cercano al más lejano)
 */
const getParentIds = (categories, targetId) => {
    const parentIds = []
    let currentNode = categories.find(
        (cat) => cat.id?.toString() === targetId?.toString()
    )
    while (currentNode && currentNode.parentId && currentNode.parentId !== 0) {
        parentIds.push(currentNode.parentId)
        currentNode = categories.find(
            (cat) => cat.id?.toString() === currentNode.parentId?.toString()
        )
    }
    return parentIds
}

/**
 * Busca un nodo recién creado en la lista de categorías por nombre y parentId
 * @function findCreatedNode
 * @param {Array} categories - Lista plana de categorías
 * @param {string} name - Nombre de la categoría creada
 * @param {number|string|null} parentId - ID del nodo padre
 * @returns {Object|null} El nodo encontrado o null
 */
const findCreatedNode = (categories, name, parentId) => {
    if (!categories || !name) return null
    return categories.find((cat) => {
        const nameMatch = cat.name?.trim().toLowerCase() === name.trim().toLowerCase()
        const parentMatch = parentId
            ? cat.parentId?.toString() === parentId?.toString()
            : !cat.parentId || cat.parentId === 0
        return nameMatch && parentMatch
    }) || null
}

export { getParentIds, findCreatedNode }
